interface LifeModelInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function LifeModelInfoModal({ isOpen, onClose }: LifeModelInfoModalProps) {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="life-model-info-title"
      onMouseDown={onClose}
    >
      <div
        className="w-full max-w-[560px] rounded-[18px] border border-line bg-panel p-6 shadow-2xl"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-4">
          <h2 id="life-model-info-title" className="font-display text-[28px] font-light leading-tight text-text">
            You can be a life model
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="h-9 w-9 rounded-lg border border-line text-text-dim transition-colors hover:border-text/30 hover:text-text"
            aria-label="Close"
          >
            x
          </button>
        </div>
        <p className="mt-4 text-[16px] leading-relaxed text-text-dim">
          Life modeling has no weight, gender, or age requirements - on the contrary, artists often prefer a variety of subjects.
        </p>
        <p className="mt-4 text-[16px] leading-relaxed text-text-dim">
          The best models have a sense of how to hold a pose that conveys deep feeling, that has often been thought through beforehand.
        </p>
        <p className="mt-4 text-[16px] leading-relaxed text-text-dim">
          Low effort / quality profiles will be rejected. Professional photography is recommended.
        </p>
      </div>
    </div>
  );
}
